import React from "react";
import "./Footer.css";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTelegram,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import { BiChevronRight } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { useScrollToSection } from "../hooks/useScrollToSection.js";
import { FaX, FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const navigate = useNavigate();
  const scrollToSection = useScrollToSection();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          {/* <div className="newsletter">
            <h3 className="newsletter-heading">Signup Our Newsletter</h3>
            <div className="newsletter-input-group">
              <input
                type="email"
                placeholder="Write email address"
                className="newsletter-input"
              />
              <button className="newsletter-button">Go!</button>
            </div>
          </div> */}
        </div>

        <div className="footer-content">
          <div className="footer-info">
            <div className="footer-about">
              <div className="footer-logo">
                <img src="/assets/fr-logo.png" alt="Company Logo" />
              </div>
              <p className="footer-text">
                Our goal at Respected Solutions & Investment Limited is to make
                financing accessible with competitive rates while offering
                personal, business, education, car, and home loans tailored to
                our clients' needs.
              </p>
            </div>
            <p
              className="footer-address"
              style={{ textDecorationLine: "underline" }}
              onClick={() =>
                (window.location.href =
                  "https://maps.app.goo.gl/SEENu3i4dj52jHANA?g_st=iw")
              }
            >
              <MdLocationOn className="footer-location-icon" />
              Suite N17-N19, Ikota Shopping Complex, Rd 4, Vgc, Ajah, Lekki
              101222, Lagos.
            </p>
            <p
              className="footer-address"
              style={{ textDecorationLine: "underline" }}
              onClick={() =>
                (window.location.href =
                  "https://maps.app.goo.gl/X33QQ9jwJLZqpPPo9?g_st=iw")
              }
            >
              <MdLocationOn className="footer-location-icon" />
              38b Adebayo Doherty Rd, Lekki Phase 1, Lekki 106104, Lagos
            </p>
            <p 
              className="footer-address">
              style={{ textDecorationLine: "underline" }}
              onClick={() =>
                (window.location.href =
                  "https://maps.app.goo.gl/xgZvcEhauZ1NcJvq7?g_st=iwb")
        }
            >
              <MdLocationOn className="footer-location-icon" />
              96 Elelenwo Close GRA Phase II, Port Harcourt, Rivers State
            </p>
          </div>

          <div className="footer-right">
            <div className="footer-links">
              <ul>
                <li
                  onClick={() => {
                    scrollToSection("home");
                  }}
                >
                  <BiChevronRight className="footer-icon" /> Home
                </li>
                <li
                  onClick={() => {
                    scrollToSection("about");
                  }}
                >
                  <BiChevronRight className="footer-icon" /> About Us
                </li>
                <li
                  onClick={() => {
                    navigate("/contact-us");
                  }}
                >
                  <BiChevronRight className="footer-icon" /> Contact Us
                </li>
              </ul>
              <ul>
                <li
                  onClick={() => {
                    navigate("/loan-against-cars");
                  }}
                >
                  <BiChevronRight className="footer-icon" /> Cars
                </li>
                <li
                  onClick={() => {
                    navigate("/loan-against-luxury-watches");
                  }}
                >
                  <BiChevronRight className="footer-icon" /> Luxury Watches
                </li>
                <li
                  onClick={() => {
                    navigate("/loan-against-jewelry");
                  }}
                >
                  <BiChevronRight className="footer-icon" /> Jewelries
                </li>
                <li
                  onClick={() => {
                    navigate("/contact-us");
                  }}
                >
                  <BiChevronRight className="footer-icon" /> Apply
                </li>
              </ul>
            </div>
            <div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/respectedsolution_lekki?utm_source=qr&igsh=MTk1d3RudzF1bDkwdw==",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaInstagram className="footer-icon" />
                Instagram
              </div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://www.facebook.com/share/17jSwASLWt/?mibextid=wwXIfr",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaFacebook className="footer-icon" />
                Facebook
              </div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/company/respected-solution-and-investment/",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaLinkedin className="footer-icon" />
                LinkedIn
              </div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://www.tiktok.com/@respected.solution?_t=ZM-8v4tBKgb5ug&_r=1",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaTiktok className="footer-icon" />
                TikTok
              </div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://t.me/respected0001",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaTelegram className="footer-icon" />
                Telegram Channel
              </div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://whatsapp.com/channel/0029VbBs28bI7BeOM1HWKb1M",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaWhatsapp className="footer-icon" />
                WhatsApp Deals Channel
              </div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://wa.me/2349114351195",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaWhatsapp className="footer-icon" />
                WhatsApp +234 911 435 1195
              </div>
              <div
                className="footer-social"
                onClick={() =>
                  window.open(
                    "https://www.youtube.com/@RespectedSolution",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                <FaYoutube className="footer-icon" />
                Youtube
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© Copyright 2025 | Respected Solutions & Investment Ltd</p>
          <p>Terms of use | Privacy Policy</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
